import { Component, OnInit, ChangeDetectorRef, ViewChild, Inject } from '@angular/core';
import { CardItems } from './cards-items.data';
import { CardItemsModel } from '../../shared/models/card-items.model';
import { Router } from '@angular/router';
import { HomeService } from '@sc/pas-common';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AnalyticsService } from '@sc/pas-common';
import { ModalService } from '../shared/modal/modal.service';
import { HomeUrlHelper } from '@sc/pas-common';
import { DashboardService } from './dashboard.service';
import { MainSideBarService } from '../shared/main-side-bar/main-side-bar.service';
import { FeatureToggleService } from '@sc/pas-common';

@Component({
    selector: 'sc-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})

export class DashboardComponent implements OnInit {

    cardItems: Array<CardItemsModel> = CardItems;
    public policyIframeState: any;
    public modalOperationOptions: any;
    public isPolizaOpen = false;
    public isPolizaClosed: boolean;
    public isPolizaFullOpen: boolean;
    public isPolizaMidOpen: boolean;
    insuring = false;
    private stateObserver: any;
    loadingPolicy: boolean;
    iframeSRC: string;
    polizaBaseURL: string;
    public token: string | null;
    private user: any;
    private successfullyOpened: boolean;
    newsUrl: string;
    isIframeNewsLoaded = false;
    loading = false;
    public messageBackToOldPortal = '';
    public backOldPortalModalOptions = {
        closeButton: true,
        closeButtonColor: 'primary',
        size: 'medium',
        buttons: []
    };
    public helpDeskUrl: string = 'https://serviciospas.sancristobal.com.ar/';
    @ViewChild('polizaIframe', { static: true }) polizaIframe: any;
    @ViewChild('polizaIframeContainer', { static: true }) polizaIframeContainer: any;
    @ViewChild('bannerVideoModal', { static: true }) bannerVideoModal: any;

    constructor(
        private router: Router,
        private homeService: HomeService,
        public modalService: ModalService,
        private analyticsService: AnalyticsService,
        private urlHelper: HomeUrlHelper,
        private dashboardService: DashboardService,
        private sideBarService: MainSideBarService,
        @Inject('Window') private window: any,
        private featureToggleService: FeatureToggleService
    ) { }

    ngOnInit() {
        if (this.featureToggleService.features) {
            this.cardItems = this.cardItems.filter(x => !this.featureToggleService.features.find(y => y.id == x.hideForFeatureToggle));
            this.cardItems = this.cardItems.filter(x => !x.showForFeatureToggle || (x.showForFeatureToggle && this.featureToggleService.features.find(y => y.id == x.showForFeatureToggle)));
        }
        else {
            this.cardItems = this.cardItems.filter(x => !x.showForFeatureToggle);
        }

        this.getNews();
    }

    buildIframeUrl(value) {
        window.parent.postMessage({ loading: true }, '*');
        const hash = localStorage.getItem('hash');
        this.iframeSRC = `${this.polizaBaseURL}#/auth?tk=${this.token}&fromHome=true${(hash ? '&p=' + hash : '')}${(value.open ? '&id=' + value.open : '&new=true')}${(value.opportunityId ? '&opportunityId=' + value.opportunityId : '')}${(value.branchOffice ? '&branchOffice=' + value.branchOffice : '')}${(value.number ? '&number=' + value.number : '')}${(value.organizerNumber ? '&organizerNumber=' + value.organizerNumber : '')}`;
    }

    onHandleCardClick(cardItem: CardItemsModel) {
        this.router.navigate(['/' + cardItem.link]);
    }

    goToNews() {
        this.router.navigate(['/novedades']);
    }
    getNews() {
        this.homeService.getShowNewsModal().subscribe(
            (response: any) => {
                if (!response.readed) {
                    this.newsUrl = response.path;
                    this.modalOperationOptions = {
                        closeButton: true,
                        closeButtonColor: 'primary',
                        size: 'large',
                        buttons: [],
                        noPadding: true
                    };
                    this.modalService.open('welcomeModal');
                }
            }
        );
    }

    onIframeNewsLoad(event) {
        this.isIframeNewsLoaded = true;
    }

    onHandleNewsClick() {
        this.modalService.close('welcomeModal');

        this.homeService.putNewsReadedForUserLogged().subscribe();
    }

    goToOldPortal() {
        this.dashboardService.getHasUserBackToOldPortal().subscribe((response: boolean) => {
            if (response)
                this.redirectToOldPortal();
            else
                this.modalService.open('backToOldPortal');
        }, () => {
            this.modalService.open('backToOldPortal');
        });
    }

    onModalOldPortalCancel() {
        this.modalService.close('backToOldPortal');
    }

    onConfirmOldPortal() {
        this.dashboardService.postUserGoesBackToOldPortal(this.messageBackToOldPortal).subscribe().add(() => {
            const keys = Object.keys(this.user);
            const keyName = keys && keys.find(k => k.includes('name'));

            const data = {
                message: this.messageBackToOldPortal,
                dateTime: new Date().toISOString(),
                userId: this.user.UserId,
                userName: this.user[keyName]
            }

            this.analyticsService.AppInsights.event('volver_portal_legado', data);
            this.messageBackToOldPortal = '';
            this.redirectToOldPortal();
            this.modalService.close('backToOldPortal');
        });
    }

    redirectToOldPortal() {
        const url = this.urlHelper.urlByOrigin('/HomeProductores.aspx', 'LEGACY_PORTAL');
        this.urlHelper.addTokenUrlItem(url, 'LEGACY_PORTAL', { showHeader: true }).subscribe(
            urlRedirect => {
                window.open(urlRedirect);
            }
        );
    }

    openBannerVideoModal() {
        this.bannerVideoModal.open();
    }

    hasAccessToBriefcase() {
        if (this.featureToggleService.features) {
            return this.featureToggleService.features.find(x => x.id == 'cartera');
        }
        else {
            return false;
        }
    }

    handleHelp() {
        this.window.open(this.helpDeskUrl, '_blank');
    }

    goToPersonalizeYourBrochures() {
        const url = this.urlHelper.getUrlSoportePas('comunicacion/personaliza-tus-folletos');
        this.window.open(url, '_blank')
    }
}
